/**
 * Optional telemetry seam for copilot-toolkit's page-to-agent boundary. A
 * consumer supplies an implementation via `<CopilotProvider telemetry={...}>`;
 * the OTel-backed one is `createCopilotTelemetry` in opentelemetry-fe. It is
 * injected rather than imported so copilot-toolkit takes on no OTel dependency,
 * and never dispatches a message, so it cannot drop a user's action.
 *
 * `skillInvoked` returns optional headers (e.g. a W3C `traceparent`) for the
 * caller to merge into the outgoing INVOKE_BREEZE_SKILL `turnMetadata`, so a
 * skill invoke can later be stitched to its backend turn
 * (fe-observability-ideas#1597).
 */

export const noopCopilotTelemetry = {
  skillInvoked: () => undefined,
  skillInvokeDropped() {},
  channelMessageSent() {},
  appContextUpdated() {}
};